"use client";

export async function generateHmac(data, apiSigningKey) {
  const encoder = new TextEncoder();

  // 1. Convert strings to Uint8Array
  const keyData = encoder.encode(apiSigningKey);
  const messageData = encoder.encode(data);

  // 2. Import the key for HMAC-SHA256
  const cryptoKey = await window.crypto.subtle.importKey(
    "raw",
    keyData,
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );

  // 3. Generate the HMAC signature (equivalent to hash_hmac with raw_output=true)
  const signatureBuffer = await window.crypto.subtle.sign(
    "HMAC",
    cryptoKey,
    messageData
  );

  // 4. Convert ArrayBuffer to Base64 (equivalent to base64_encode)
  const hashArray = new Uint8Array(signatureBuffer);

  // modern browsers (2025+)
  if (hashArray.toBase64) {
    return hashArray.toBase64();
  }

  // legacy fallback
  return btoa(String.fromCharCode(...hashArray));
}
